import { FC, memo } from "react"
import ReactModal from "react-modal"

import styled from "styled-components"

import { colors, size, spacing } from "@izettle/otto"

import { DropdownItemContainer } from "../internal"

const StyledModalAdapter: FC<ReactModal.Props> = memo(({ className, ...props }) => (
  <ReactModal
    ariaHideApp={false}
    className={`${className}__modal`}
    overlayClassName={`${className}__overlay`}
    portalClassName={className as string}
    {...props}
  />
))

export const StyledModal = styled(StyledModalAdapter)`
  &__overlay {
    background: ${colors.background.default};
    bottom: 0px;
    left: 0px;
    position: fixed;
    right: 0px;
    top: 0px;
    z-index: 1000;
  }

  &__modal {
    background: ${colors.background.default};
    display: flex;
    flex-direction: column;
    height: 100%;
    left: 0;
    overflow: scroll;
    position: absolute;
    top: 0;
    width: 100%;
  }
`

export const List = styled.div`
  flex: 1;
  overflow: scroll;

  ${DropdownItemContainer} {
    border-bottom: 1px solid ${colors.border.divider};
    height: ${size.large};
  }
`

export const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.border.divider};
  display: flex;
  justify-content: flex-end;
  padding: ${spacing.small} ${spacing.medium};
`

export const Footer = styled.div`
  align-items: center;
  border-top: 1px solid ${colors.border.divider};
  display: flex;
  justify-content: flex-end;
  padding: ${spacing.xSmall} ${spacing.medium};
`
